import http, {makeSearchParams} from 'utils/http';

export const getAccreditationBodies = (queries) => {
  return http('GET', '/ab', makeSearchParams(queries));
};

export const getAccreditationBody = (id) => {
  return http('GET', `g/ab/${id}`);
};

export const getPublicAccreditationBodies = (queries) => {
  return http('GET', 'g/ab', makeSearchParams(queries));
};

export const getPublicAccreditationScopes = (id, queries) => {
  return http('GET', `g/ab/${id}/scopes`, makeSearchParams(queries));
};

export const getPublicAccreditationBodiesByCb = (cbId, queries) => {
  return http('GET', `g/cb/${cbId}/ab`, makeSearchParams(queries));
};

export const getPublicABLocations = (abId, queries) => {
  return http('GET', `g/ab/${abId}/locations`, makeSearchParams(queries));
};

// AB Report Stats in Dashboard
export const getABReport = (data) => {
  return http('GET', 'ab/report', makeSearchParams(data));
};

export const getAccreditationBodiesHaveStandards = (queries) => {
  return http('GET', 'cb/ab', makeSearchParams(queries));
};

export const getAccreditationBodiesHaveStandardsMncb = (cbId, queries) => {
  return http('GET', `cb/${cbId}/accreditation`, makeSearchParams(queries));
};
